<div>
  <app-dtc-list [dtcs]="items" (scrolledToBottom)="onScrolledToBottom()"></app-dtc-list>
</div>
